import en from "../el-ui-locales/en";

export default {
  ...en,

  At: 'At',
  select_team: "Select team",
  type_of_preview: "Type of preview",
  detail_view: "Detail view",
  summary_view: "Summary view",

  // presence drawer
  select_an_employee: "Select an employee",
  enter_date: "Enter date",
  presence_type: "Presence type",
  strict_time: "Strict time",
  select_work_shift: "Select work shift",
  until_the_end_of_the_week: "until the end of the week",
  until_the_end_of_the_month: "until the end of the month",
  edit_schedule: "Edit schedule",
  required: "Required",
  sliding_time: "Sliding time",
  final_start_time: "Final start time",
  number_of_working_hours: "Number of working hours",

  are_you_sure: "Are you sure?",
  confirm: "Confirm",
  are_you_sure_update_presence: "Are you sure you want to update this presence?",
  yes_update_it: "Yes, update it",
  are_you_sure_create_presence: "Are you sure you want to create this presence?",
  yes_create_it: "Yes, create it",
  are_you_sure_delete_presence: "Are you sure you want to delete this presence?",
  yes_delete_it: "Yes, delete it",
  are_you_sure_create_scheduler: "Are you sure you want to create this scheduler/s?",
  yes_create_scheduler: "Yes, create it",
  
  // expand button texts in weekly totals
  view_detail_work: "View Details Work",
  hide_detail_work: "Hide Details Work",

  // navigation bar
  dashboard: "Home",
  presence: "Presence",
  calendar: "Calendar",
  my_presence: "My presence",
  my_calendar: "My Calendar",
  reports: "Reports",
  shift_reports: "Shifts Report",
  my_profile: "My Profile",
  hi: "Hi",
  logout: "Logout",
  // footer
  made_by: "made by",
  version: "Version",
  cookie_policy: "Cookie Policy",
  privacy_policy: "Privacy Policy",
  // tables
  no_data_available: "No data available",
  showing_entries: "Showing {from} to {to} of {total} entries",
  go_to: "Go to",
  page_size: "{size}/page",
  person1: "Person",
  department: "Department",
  team: "Team",
  type_of_absence: "Type of absence",
  requested_period: "Requested period",
  requested_days: "Requested days",
  submitted_at: "Submitted at",
  period: "Period",
  start_date: "Start date",
  years_in_company: "Years in company",
  pending_absence_requests: "Pending absence requests",
  pending_absence_request: "Pending absence request",
  todays_absences: "Today's absences",
  todays_absence: "Today's absence",
  start_tomorrow_absences: "People whose absences starts tomorrow",
  start_tomorrow_absence: "Person whose absence starts tomorrow",
  upcoming_work_anniversary: "Upcoming work anniversary",
  upcoming_work_birthdays: "Upcoming birthdays",

  // Presence
  success: "Success",
  search: "Search",
  your_input_was_saved_successfully: "Your input was saved successfully",
  //**********from absent my_presence.php**********//
  today_presence: "Today's Presence",
  clock_in: "Clock in",
  clock_out: "Clock out",
  break_start: "Break start",
  break_stop: "Break stop",
  private_exit_start: "Private exit start",
  private_exit_stop: "Private exit stop",
  From: "From",
  To: "To",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  paid_break: "Paid Break",
  absence: "Absence",
  total_regular_time: "Total regular time",
  private_exit: "Private exit",
  per_page: "Per page",
  weekly_presence: "Weekly Presence",
  prev_week: "Previous week",
  week: "Week",
  next_week: "Next week",
  no_data: "No data",
  presence_history: "Presence History",
  cancel: "Cancel",
  cancelled: "Cancelled!",
  field_work_start: "Field work start",
  field_work_stop: "Field work stop",
  holiday: "Holiday",
  unauth_absence: "Unauthorized Absence",
  scheduled_time: "Scheduled Time",
  //--------from absent presence.php--------//
  work: "Work",
  break: "Paid Break",
  field_work: "Field work",
  create: "Create",
  update: "Update",
  delete: "Delete",
  close: "Close",
  save_changes: "Save changes",
  monday_short: "Mon",
  tuesday_short: "Tue",
  wednesday_short: "Wed",
  thursday_short: "Thu",
  friday_short: "Fri",
  saturday_short: "Sat",
  sunday_short: "Sun",
  updated_end_time: "Updated<br>end time",
  edit_presence: "Edit presence",
  person: "Person",
  date: "Date",
  type: "Type",
  action: "Action",
  updated_start_time: "Updated<br>start time",
  prev_start_time: "Previous<br>start time",
  previous_start_time: "Previous start time",
  prev_end_time: "Previous<br>end time",
  previous_end_time: "Previous end time",
  duration: "Duration",
  last_comment: "Last Comment",
  last_updated_by: "Last updated by",
  last_updated_at: "Last updated at",
  employee: "Employee",
  select_time: "Select time",
  comment: "Comment",
  holiday: "Holiday",
  total_for: "Total for",
  comment_for_this_presence: "Comment for this presence",
  updated_from_overlapped_presence: "Updated from overlapped presence",
  deleted_from_overlapped_presence: "Deleted from overlapped presence",
  reason_for_updating: "Reason for updating",
  max_length_is_250_characters: "Max length is 250 characters.",
  work_shift: "Work shift",
  rest_day: "Rest day",
  presence_on_rest_day: "Presence on rest day",
  selected_day: "selected day",
  schedule_for: "Schedule for",
  nothing_selected: "Nothing selected",
  at: "At:",
  logged_at: "Logged at:",
  shift_name: "Shift name:",
  shift_start: "Shift start:",
  shift_end: "Shift end:",
  custom: "Custom",
  presence_on_holiday: "Presence On Holiday",
  presence_on_absence: "Presence On Absence",
  break_on_holiday: "Break on holiday",
  break_on_absence: "Break on absence",
  field_work_on_holiday: "Field work on holiday",
  field_work_on_absence: "Field work on absence",
  presence_on_rest_day: "Presence On Rest Day",
  field_work_on_rest_day: "Field work on rest day",
  break_on_rest_day: "Break on rest day",
  presence_on_night_work: "Presence on night work",
  field_work_on_night_work: "Field work on night work",
  break_on_night_work: "Break on night work",
  exceeded_break: "Exceeded Break",
  overtime_work: "Overtime work",
  unpaid_absence: "Unpaid Absence",
  description: "Description",
  weekly_total_time : "Weekly Total Time",
  no_results_found_matching_your_search: "No results found matching your search",
  start: "Start",
  end: "End",
  // end of presence
  //my calendar
  no_right_to_use_vacation: 'You still do not have the right to use a vacation',
  cannot_take_vacation_in_selected_period: 'You can not take a vacation in the selected period',
  days_exceed_annual_limit: 'The required days are more than the days for annual leave in this period',
  overlapping_personal_days: 'Personal days end period is overlapping with another absence.',
  overlapping_absence: 'User already has an absence in this period.',
  overlapping_period_or_switch_day: 'User already has an absence with this period/switch day.',

  schedule_vacation_days: "Schedule vacation days",
  schedule_vacation_modal:
    "Please click for start and for end date on the calendar",
  ok: "Ok",
  remaining: "Remaining",
  pending: "Pending",
  used: "Used",
  period_of_usage: "Period of usage",
  calculation_from: "Calculation from",
  to: "to",
  from: "from",
  of: "of",
  entries: "entries",
  showing: "Showing",
  create_period: "Click one more date to create a period",
  period: "Period",
  create_absence: "Create absence",
  employees: "Employees",
  type_of_leave: "Type of leave",
  personal_days_type: "Personal days type",
  select_type_of_leave: "Select type of leave",
  type_of_personal_days: "Select type of personal days",
  comment: "Comment",
  absence_declied: "Absence was successfully declined",
  file_uploaded: "File successfully uploaded",
  upload_absence_doc: "Upload absence document",
  attach_doc: "Attach document",
  choose_files: "Choose Files",
  no_file_chosen: "No file chosen",
  pdf_size: "PDF file should not be more than 1MB",
  files_allowed: "Only PDF JPG, JPEG files are allowed",
  size_of_file: "A single JPG, JPEG file should not be more than 10MB",
  max_allowed_files: "Maximum allowed files are",
  file_limit_exceeded:
    "The limit is {fileLimit} files. You can select {remainingFiles} more files.",
  submitting: "Submitting ...",
  submit: "Submit",
  saving: "Saving ...",
  save_file: "Save file",
  pdf_file_not_exceed: "PDF file size should not exceed",
  img_file_not_exceed: "Image file size should not exceed",
  my_absence_logs_title: "My absence logs",
  requested_period: "Requested Period",
  requested_days: "Requested days",
  name_of_vacation: "Name of vacation",
  updated_at: "Updated at",
  status: "Status",
  action: "Action",
  search: "Search",
  no_data_available: "No data available",
  submitted_by: "Submitted By:",
  approved_by: "Approved By:",
  declined_by: "Declined By:",
  pending_approval_by: "Pending Approval By:",
  on: "On",
  at: "At",
  comment_presence: "Comment for this presence from:",
  approve: "Approve",
  approved: "Approved",
  decline: "Decline",
  declined: "Declined",
  upload_files: "Upload files",
  download_files: "Download files",
  decline_absence_request: "Are you sure you want to decline this <br> absence request?",
  approve_absence_request: "Are you sure you want to approve this <br> absence request?",
  decline_rest_day_request: "Are you sure you want to decline this <br> rest day request?",
  write_reason: "Please write a reason",
  decline_it: "Yes, decline it!",
  approve_it: "Yes, approve it!",
  vacation: "Vacation",
  presonal_days: "Personal days",
  sick_leave: "Sick leave",
  business_trip: "Business trip",
  work_from_home: "Work from home",
  extra_days: "Extra days",
  switched_day: "Switched day",
  paid_patental_leave: "Paid parental leave",
  unpaid_patental_leave: "Unpaid parental leave",
  unpaid_leave: "Unpaid leave",
  rest_day: "Rest day",
  marriage: "For making a marriage",
  child_marriage: "For the marriage of a child",
  adoption_child: "For the birth or adoption of a child",
  death_spouse_child: "For the death of a spouse or child",
  death_parent_brother_sister: "For the death of a parent, brother, sister",
  death_parent_spouse: "For the death of a parent of a spouse",
  death_grandfather_grandmother:
    "For the death of a grandfather or grandmother",
  needs_of_employer:
    "For taking an expert or other exams for the needs of the employer",
  natural_disasters: "For natural disasters",
  moving_family_from_one_to_another_place:
    "For moving the family from one place to another",
  moving_family_to_the_same_place: "For moving the family to the same place",
  you_get_num_days: ", you get {n} day. | , you get {n} days.",
  public_holiday: "Public holiday",
  holiday: "Holiday",
  profile_settings: "Profile Settings",
  update_picture: "Update Picture",
  change_password: "Change Password",
  email_address: "Email address",
  full_name: "Full name",
  full_name_in_docs: "Full name in documents",
  display_job_position: "Display job position",
  job_position_in_docs: "Job position in documents",
  local_language: "Enter with your local language.", // still not using
  birthday: "Birthday",
  phone_no: "Phone No.",
  nationality: "Nationality",
  religion: "Religion",
  employment_start_date: "Employment start date",
  country: "Country",
  pick_date: "Pick a date",
  symbol_placeholder: "+xx xxx xxx xxxx",
  select: "Select",
  pick_employment_date: "Pick an employment date",
  save_changes: "Save changes",
  reset: "Reset",
  // my calendar end
  // team leader calendar
  absence_type:"Absence Type",
  select_an_employee:"Select an employee",
  absence_requests_for_team:"Absence requests for team",
  person2:"Person",
  use_period:"Period of usage:",
  remaining_days: "Remaining days",
  pending_days:"Pending days",
  used_days: "Used days",
  no_vacations_in_this_period_for_this_user: "There are no vacations in this period for this user",
  info: "No action is available after being declined",
  info_waiting_approval:"Waiting on approval by",
  pending_approval: "Pending",
  decline_approval: "Decline",
  approved_absence: "Approved",
  declined_approval: "Declined",
  permissions_to_perform_any_actions:"You do not have any permissions to perform any actions",
  info_title: "Info",
  add_user: "Add User",
  download_all_qr_code: "Download all QR Codes",
  block: "Block",
  edit_details: "Edit details",
  // team leader calendar end
  // Gm and sysadmin calendar start
  edit_comment: "Edit comment",
  comment_required: "The comment field is required",
  comment_successfully_updated: "Comment successfully changed",
  edit_comment: "Edit comment",
  // Gm and sysadmin calendar end
  // department leader start
  department: "Department",
  // department leader end
  // Teams start
  teams: "Teams",
  team_lead: "Team lead",
  add_team: "Add Team",
  team_name: "Team name",
  team_members: "Team members",
  team_successfully_created: "Team successfully created",
  team_successfully_deleted: "Team successfully deleted",
  delete_this_team: "Are you sure want to delete this Team?",
  not_be_able_to_revert: "You will not be able to revert this!",
  yes_decline_it: "Yes, delete it!",
  select_department: "Select a department",
  team_name_required: "Department is required",
  select_an_option: "Select an option",
  department_required: "Department is required",
  team_lead_required: "Team lead needs to be selected",
  create_team: "Create New Team",
  edit_team: "Edit Team",
  team_successfully_updated: "Team Successfully Updated",
  team_successfully_approved: "Team Successfully Updated",
  team_successfully_declined: "Team Successfully Updated",
  pending_requests: "When changing team leaders all pending requests must be approved or rejected",
  approve_all: "Approve all",
  decline_all: "Decline all",
  approve_requests: "Are you sure you want to approve all requests?",
  yes_approve_all: "Yes, Approve all",
  decline_requests: "Are you sure you want to decline all requests?",
  yes_decline_all: "Yes, Decline all",
  // Teams end
  // Gates start
  gates: "Gates",
  number_of_devices: "Number of devices",
  name: "Name",
  // Gates end
  // Settings start
  company_settings: "Company Settings",
  company_language: "Company Language:",
  show_qr_code_my_presence_page: 'Show QR code in "My Presence" page',
  enable_disable_two_factor_via_email: "Enable/Disable Two Factor Authentication via email",
  use_pass_reset_3_months: "User password reset on every 3 months.",
  enable_saving_images: "Enable saving images.",
  min_days_before_vacation_request: "Minimum days before vacation request:",
  disable_emails_for_gm: "Disable emails for General Manager",
  disable_emails_for_dm: "Disable emails for Department Manager",
  disable_emails_for_chairman: "Disable emails for Chairman",
  allow_approval_for_absence_req: "Allow approval for absence requests:",
  general_manager: "General Manager",
  human_resources: "Human resources",
  department_lead: "Department lead",
  allways_show_saturday: "Allways show saturday",
  allways_show_sunday: "Allways show sunday",
  add_shift: "Add shift",
  company_timezone: "Company Timezone:",
  show_presence_history_for_tm: "Show presence history for team member",
  gm_can_schedule_vacation_in_the_past: "General menager can schedule vacation in the past",
  sysadmin_can_schedule_vacation_in_the_past: "System administrator can schedule vacation in the past",
  hr_can_schedule_vacation_in_the_past: "Human resources can schedule vacation in the past",
  dl_can_schedule_vacation_in_the_past: "Department leader can schedule vacation in the past",
  tl_can_schedule_vacation_in_the_past: "Team leader can schedule vacation in the past",
  dm_can_schedule_work_time_and_rest_days: "Department Manager can schedule work time and rest day/s for himself/herself",
  tl_can_schedule_work_time_and_rest_days: "Team leader can schedule work time and rest day/s for himself/herself",
  absence_will_be_approved_by: "Absences will be approved by:",
  start_time_rounding_range_margin: "Start time rounding range margin:",
  end_time_rounding_range_margin: "End-time rounding range margin:",
  flexible_working_hours_margin: "Flexible working hours margin:",
  enable_night_work: "Enable night work",
  define_period_for_logging_working_hours: "Define a period for logging working hours",
  night_work_start_time: "Start of night work",
  night_work_end_time: "End of night work",
  logging_period_start_time: "Beginning of the log period",
  logging_period_end_time: "End of log period",
  night_work_is_turned_on_please_enter_a_night_work_period: "Night work is turned on please enter a night work period!",
  period_for_logging_work_hours_is_turned_on_please_select_work_hours_period: "Period for logging work hours is turned on, please select work hours period!",
  company_settings_successfully_updated: "Company settings successfully updated",
  are_you_sure_want_perform_this_action: "Are you sure you want to perform this action?",
  and: "AND",
  or: "OR",
  end_time_greater_than_start_time: "End time must be greater than start time for the log period.",
  enter_shift_name: "Enter shift name",
  select_timezone: "Select timezone",
  // Settings End
  // NonRoundedPresenceReports Start
  non_rounded_presence_reports: "Non-Rounded Presence Reports",
  // NonRoundedPresenceReports End
  // Sentice Start
  company_sentice: "Company:",
  report_prefix: "Report",
  sentice_report: "Report for Sentice clients",
  // Sentice End
  // Avatar Tab
  upload_or_drop_picture: "Click here to upload or drop picture here.",
  image_allowed: "Only image files are allowed for upload", //still not using
  image_is_uploaded: "Image is uploaded",
  // Password Tab
  password_updated_successfully: "Password updated successfully",
  password_rules:
    "The password must be a combination of at least eight alphanumeric characters (lowercase and uppercase), symbols, numbers, and punctuation.",
  new_password: "New password",
  repeat_password: "Repeat password",
  old_password: "Old Password",
  code: "Code",
  // LoginController
  invalid_credentials: "Invalid Credentials",
  you_dont_have_company_manager_account:
    "You don’t have a company or manager account",
  // logoutController
  gate_does_not_exist: "This gate does not exist in our database!",
  user_is_logged_out: "User is logged out", // User is logout
  unauthorized: "Unauthorized",
  // ProfileApiController
  changing_starting_date:
    "For changing the starting date of an employee please make all hers/his absences declined!!",
  error: "Error",
  profile_was_successfully_updated: "Profile was successfully updated",
  password_changed_successfully: "Password changed successfully",
  avatar_changed_successfully: "Avatar changed successfully",
  // Shift Reports
  period_from: "Period from:",
  period_to: "Period to:",
  select_date: "Select date",
  department: "Department:",
  generate: "Generate",
  export: "Export",
  team: "Team:",
  user: "User:",
  all_without_deactivated: "All, without deactivated",
  all: "All",
  person_report: "Person",
  day_day: "Day",
  shiftName: "Shift",
  dateDate: "Date",
  shiftStartTime: "Scheduled start time",
  shiftEndTime: "Scheduled end time",
  shiftTotalTime: "Total scheduled",
  total_reports: "Total",
  shifts_report: "AbSent Shifts report", 
  invalid_input_data: "An error occurred",
  // Calendar Reports
  calendar_reports: "Calendar Report",
  cumulative_report: "Cumulative report",
  absent_cumulative_report: "AbSent Cumulative report",
  periodic_report: "Periodic report",
  absent_periodic_report: "AbSent Periodic report",
  toggle_columns: "Toggle columns:",
  annual_leave_unused: "Annual leave - Unused",
  annual_leave_pending: "Annual leave - Pending",
  annual_leave_used: "Annual leave - Used",
  vacation_name: "Name of vacation",
  personal_days: "Personal days",
  paid_parental_leave: "Paid parental leave",
  unpaid_parental_leave: "Unpaid parental leave",
  // Presence Reports
  presence_reports: "Presence Report",
  cumulative: "Cumulative",
  daily: "Daily",
  detailed: "Detailed",
  choose_user: "Choose user",
  expected_regular_time: "Expected regular time",
  expected_and_total_time_difference: "Expected and total time difference",
  overtime_work: "Overtime work",
  total_scheduled: "Total scheduled",
  expected_and_total_time_difference_with_overtime: "Expected and total time difference with overtime",
  total_logged_hours: "Total logged hours",
  unauthorized_absence: "Unauthorized absence",
  scheduled_start_time: "Scheduled start time",
  logged_start_time: "Logged start time",
  scheduled_end_time: "Scheduled end time",
  logged_end_time: "Logged end time",
  note: "Note",
  day_and_date: "Day / Date",
  time: "Time",
  registered_on: "Registered on",
  show_image: "Show image",
  role: "Role:",
  direct_superior: "Direct superior:",
  report_generated_on: "Report generated on:",
  small_at: "at",
  selected_period: "Selected period:",
  presence_details: "Presence Details",
  presence_type: "Presence Type",
  start_time: "Start Time",
  end_time: "End Time",
  registered_start_time: "Registered on",
  registered_end_time: "Registered to",
  presence_image: "Presence image",
  image_save_at: "Image saved at",
  small_on: "on",
  presence_report_excel: "AbSent Presence report",
  presence_report_pdf: "AbSent Detailed report",
  // Administrative Report
  administrators_report: "Administrators report",
  attendance_images_reviewed: "Attendance images reviewed",
  reviewed_by: "Reviewed by:",
  date_and_time_of_review: "Date and time of review:",
  image_of: "Image of:",
  image_saved_on: "Image saved on:",
  saved_from_device: "Saved from device:",
  show_images: "Show images:",
  absent_attendance_images_reviewed: "AbSent Attendance images reviewed",
  // Nationality And Religion
  settings: "Settings",
  add_nationality: "Add Nationality",
  add_religion: "Add Religion",
  nationality_religion: "Nationality/Religion",
  nationality: "Nationality",
  religion: "Religion",
  nationality_required: "Nationality is required",
  edit_nationality: "Edit Nationality",
  delete_this_nationality: "Are you sure want to delete this nationality?",
  uneditable: "Uneditable",
  delete_nationality: "Delete Nationality",
  nationality_successfully_deleted: "Nationality was successfully deleted",
  nationality_successfully_updated: "Nationality successfully updated",
  other: "Other",
  nationality_successfully_created: "Nationality successfully created",
  create_nationality: "Create Nationality",
  create_religion: "Create Religion",
  edit_religion: "Edit Religion",
  delete_religion: "Delete Religion",
  religion_successfully_updated: "Religion successfully updated",
  delete_this_religion: "Are you sure want to delete this religion?",
  religion_successfully_deleted: "Religion was successfully deleted",
  religion_successfully_created: "Religion successfully created",
  religion_required: "Religion is required",
  // Users
  users: "Users",
  active_users: "Active Users",
  deactivated_users: "Deactivated Users",
  blocked_users: "Blocked Users",
  email: "Email",
  phone: "Phone",
  qr_code: "QR Code",
  work_rules: "Work rules",
  deactivated_at: "Deactivated at",
  activate: "Activate",
  are_you_sure_want_to_activate_this_user: "Are you sure want to activate this user?",
  yes_activate_it: "Yes, activate it!",
  user_was_successfully_activated: "User was successfully activated",
  user_was_successfully_unblocked: "User was successfully unblocked",
  are_you_sure_want_to_unblock_this_user: "Are you sure want to unblock this user?",
  yes_unblock_it: "Yes, unblock it!",
  unblock: "Unblock",
  user_was_successfully_blocked: "User was successfully blocked",
  are_you_sure_want_to_block_this_user: "Are you sure want to block this user?",
  yes_block_it: "Yes, block it!",
  email_address_required: "Email address is required",
  employee_start_date: "Employment start date",
  account_type: "Account type",
  belongs_to_the_department: "Belongs to the department",
  enter_account_details: "Enter account details",
  belongs_to_the_team: "Belongs to the team",
  employee_start_date_required: "Employment start date is required",
  account_type_required: "Account type is required",
  belongs_to_department_required: "Belongs to the department is required",
  team_required: "Belongs to the team is required",
  select_team: "Select a team",
  select_department: "Select a department",
  select_date_form: "Select date",
  enter_personal_details: "Enter personal details",
  full_name_to_display: "Full name for display",
  full_name_required: "Full name in documents is required",
  job_position_in_docs_required: "Job position in documents is required",
  display_job_position_required: "Display job position is required",
  full_name_to_display_required: "Full name is required",
  select_religion: "Select religion",
  select_country: "Select country",
  select_nationality: "Select nationality",
  display_job_position_users: "Display job position",
  differentiation_color: "Differentiation Color",
  select_type: "Select a type",
  administration: "Human Resources",
  teamlead: "Team Lead",
  teammember: "Team Member",
  deplead: "Department Manager",
  sysadmin: "System Administrator",
  user_successfully_created: "User was successfully created",
  date_invalid: "Invalid date",
  employee_end_date: "Employment end date",
  edit_user: "Edit user",
  edit_account_details: "Edit account details",
  edit_personal_details: "Edit personal details",
  user_successfully_updated: "User successfully updated",
  please_fill_required_fields: "Please fill required fields",
  review_and_change_rest_days: "Review and change the rest days for:",
  rest_days_sucessfully_created: "Rest days have been successfully created",
  vacation_and_rest_days: "Vacation / Rest days",
  "days": {
    "monday": "Monday",
    "tuesday": "Tuesday",
    "wednesday": "Wednesday",
    "thursday": "Thursday",
    "friday": "Friday",
    "saturday": "Saturday",
    "sunday": "Sunday"
  },
  review_and_change_number_of_days: "Review and change the number of days off for:",
  date_of_acquisition: "Date of acquisition",
  number_of_days_for_annual_leave_unused: "Number of days for annual leave - Unused",
  number_of_days_for_annual_leave_pending: "Number of days for annual leave - Pending",
  number_of_days_for_annual_leave_used: "Number of days for annual leave - Used",
  actions: "Actions",
  add_row: "Add New",
  vacation_successfully_saved: "Vacation policy was successfully updated",
  vacation_successfully_deleted: "Vacation policy was successfully deleted",
  minimum_date: "Minimum date should be",
  change_rest_days: "Review and change the rest days for",
  work_hours: "Work hours",
  review_and_change_working_hours: "Review and change working hours for:",
  max_time_paid_break: "The maximum time for a paid break",
  flexible_work_schedule: "Total regular hours for a flexible work schedule (work+field work+paid break)",
  flexible_working_hours: "If there is a shift on a given day, flexible working hours are not taken into account.",
  paid_hours_for_holiday_and_leave: 'The number of regularly paid hours for holiday and leave is calculated according to the number of "Total regular hours for a flexible work schedule".',
  automatic_presence_stop: "Enable automatic presence stop",
  enable_saving_images: "Enable saving images",
  disable_overtime_for_user: "Disable overtime for user",
  disable_presence_logging: "Disable presence logging:",
  using_the_web: "Using the web",
  using_mobile_app: "Using the mobile application",
  max_time_for_auto_presence_stop_flexible_schedule: "The maximum time for automatic presence stop for flexible work schedule ",
  work_field_work_paid_break: "(work+field work+paid break)",
  employee_no_scheduled_shift_auto_presence_stop_executed: "When an employee doesn't have a scheduled shift, the automatic presence stop is executed according to the parameters above and on a continues presence segment (work, break, field work).",
  employee_has_scheduled_shift_max_time_not_taken_into_account: "When an employee has a scheduled fixed or sliding shift, the parameter for maximum time, defined above, is not taken into account, but, the automatic presence stop is executed after the end of the shift and the end-time rounding range have passed.",
  user_has_existing_schedules_message: "Are you sure want to save working hours for this user?",
  yes_save_it: "Yes, save it!",
  data_saved_successfully: "Working hours for user was successfully saved",
  all_qr_codes: "All QR Codes",
  // Departments
  departments: "Departments",
  add_departments: "Add Departments",
  department_manager: "Department Manager",
  default: "Default",
  delete_this_department: "Are you sure want to delete this Department?",
  department_successfully_deleted: "Department was successfully deleted",
  edit_department: "Edit Department",
  delete_department: "Delete Department",
  create_department: "Create Department",
  department_name: "Department name:",
  department_manager: "Department Manager:",
  department_members: "Department members:",
  department_name_required: "Department name is required",
  department_lead_required: "Department lead needs to be selected",
  department_successfully_created: "Department successfully created",
  department_unchanged: "Department was not changed",
  department_successfully_updated: "Department successfully updated",
  // Holidays
  for_all_citizens: "For All citizens",
  year: "Year:",
  type_type: "Type",
  add_holiday: "Add Holiday",
  delete_this_holiday: "Are you sure want to delete this holiday?",
  holiday_successfully_deleted: "Holiday was successfully deleted",
  delete_holiday: "Delete Holiday",
  create_holiday: "Create Holiday",
  holiday_type: "Holiday type",
  official_holiday: "Public holiday",
  ethnic_holiday: "Ethnic",
  religious_holiday: "Religious",
  users_that_have_rest_days: "There are users that have rest days on the selected date. Are you sure that you want to delete this rest days for all users?",
  holiday_successfully_created: "Holiday successfully created",
  date_required: "Date is required",
  description_required: "Description is required",
  holiday_type_required: "Holiday type is required",
  national_type_required: "National is required",
  religious_type_required: "Religious is required",
  national_type: "National",
  religious_type: "Religious",
  select_option: "Select an option",
  holidays: "Holidays",
  // Register page
  register_company: "Register Your Company",
  email_register: "Email",
  password: "Password",
  confirm_password: "Confirm Password",
  account_type_register: "Account Type",
  by_registering_in_absent: "By registering in Absent you agree to these:",
  terms_and_conditions_register: "terms and conditions.",
  register_button: "Register",
  or_register: "or",
  login_to_your_account: "Login To Your Account",
  email_verification: "Email Verification",
  email_verified: "Email Verified Successfully!",
  your_email_successfully_verified: "Your email has been successfully verified. You can now login to your account.",
  email_verification_failed: "Email verification failed!",
  resend_verification_email: "Resend verification email",
  email_field_required: "Email",
  email_field_required: "Email is required",
  confirm_password_required: "Confirm password is required",
  role_required: "Account type is required",
  agree_terms: "Terms and conditions is required",
  password_mismatch: "Password mismatch",
  verifying_your_email: "Verifying your email...",
  "recaptcha_verification_failed": "reCAPTCHA verification failed",
  "failed_to_create_user": "Failed to create user",
  "register_unexpected_error": "Register unexpected error",
  "registration_success": "Registration successful! Please check your email to verify your account",
  "register_validation_failed": "Error during registration validation",
  "invalid_link": "The link is invalid",
  "invalid_expired_link": "The verification link is invalid or has expired",
  "already_verified": "Already verified",
  "verification_success": "The verification is successful", 
  "verification_failed": "Verification failed",
  "verification_unexpected_error": "Verification unexpected error",
  "user_not_found": "User not found", 
  "already_verified": "Already verified",
  "verification_resent": "Verification resent, please check your email",
  "resend_validation_failed": "Resending verification failed",
  "resend_unexpected_error": "An unexpected error occurred during resend",
  // PresenceApiController
  working_hours_allowed:
    "The Number of working hours are bigger that is allowed!!",
  not_found: "Not Found",
  // AbsenceApiController
  permission_to_schedule_rest_days:
    "You do not have permission to schedule days as rest days, for yourself",
  submit_absence_request:
    "To submit an absence request, selected dates should be present or future dates only!",
  to_do_this_change:
    "In order to do this change, please delete all absences of this user",
  you_can_not_create_more_than_two_rest_days:
    "You can not create more than two rest days",
  rest_day_successfully_created:
    "The rest day/s have been successfully created",
  select_one_day_to_switch: "You can select only one day to switch!!!",
  human_resources_role_can_not_create_absence:
    "Human Resources role can not create absence for other users later than:",
  submit_a_request_for_vacation:
    "To submit а request for vacation, selected date should be at least 3 working days from today",
  absence_was_successfully_created: "The absence was successfully created",
  select_at_least_one_day:
    "You must select at least one day to submit Absence!",
  comment_successfully_changed: "Comment Successfully changed",
  documents_uploaded_successfully: "Documents uploaded successfully",
  // ManagementApiController
  rest_day_was_successfully_rejected: "Rest day was successfully rejected",
  // ApiUserController
  company_does_not_exist: "This company does not exist in our database!",
  wrong_qr_code: "Wrong qr code!",
  user_does_not_exist: "This user does not exist in our database!",
  device_id_is_required: "Device id is required!",
  device_id_does_not_exist: "This device id does not exist in our database!",
  // ApiPresenceController
  management_disabled_your_logging:
    "The management of your company disabled your logging for presence!",
  gate_does_not_exist: "This gate does not exist in our database!",
  gate_is_not_active: "This gate is not active!",
  // REQUESTS
  file_field_is_required: "The file field is required.",
  file_must_be_an_image: "The file must be an image.",
  jpeg_jpg_png_files_allowed: "Only JPEG, JPG, and PNG files are allowed.",
  file_size_1MB: "The file size cannot exceed 1MB.",
  jpg_jpeg_png_images_allowed:
    "Only JPG, JPEG and PNG \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 images are allowed for upload",
  personal_days_type_field_required:
    "The personal days type field is required.",
  switch_days_field_required: "The switch days field is required.",
  comment_filed_required: "The comment field is required.",
  invalid_document_format: "Invalid document format.",
  upload_up_to_5_files: "You can upload up to 5 files.",
  invalid_file_format: "Invalid file format.",
  jpeg_pdf_file_formats_allowed: "Only JPEG and PDF file formats are allowed.",
  max_characters_allowed: "Maximum of 250 characters allowed",
  required_field: "A required field is missing or empty.",
  invalid_input: "Invalid input",
  comment_required: "The comment is required.",
  comment_250_characters: "The comment cannot exceed 250 characters.",
  no_file_selected: "No file selected.",
  jpg_jpeg_pdf_files_allowed: "Only JPG, JPEG, and PDF files are allowed.",
  uploaded_file_size_exceeds_allowed_limit:
    "The uploaded file size exceeds the allowed limit.",
  first_name_required: "First name is required",
  first_name_must_be_at_least: "First name must be at least :min characters",
  first_name_max_characters: "First name must be max :max characters",
  valid_email_address: "The email must be a valid email address",
  email_must_be_at_least: "Email address must be max :max characters",
  birthday_required: "Birthday is required",
  country_required: "Country is required",
  employment_start_date_required: "Employment start date is required",
  full_name_in_docs_required: "Full name in documents is required",
  full_name_in_docs_must_be_at_least:
    "Full name in documents must be at least :min characters",
  full_name_in_docs_max_characters:
    "Full name in documents must be max :max characters",
  employee_position_in_docs_required:
    "Employee position in documents is required",
  employee_position_in_docs_must_be_at_least:
    "Employee position in documents must be at least :min characters",
  employee_position_in_docs_max_characters:
    "Employee position in documents must be max :max characters",
  employee_position_required: "Employee position is required",
  employee_position_must_be_at_least:
    "Employee position must be at least :min characters",
  employee_position_max_characters:
    "Employee position must be max :max characters",
  email_required: "Email is required",
  email_invalid: "Email is invalid",
  email_has_already_been_taken: "The email has already been taken",
  password_required: "Password is required",
  password_confiramtion: "The password confirmation and password must match",
  password_confiramtion_required: "Password confirmation is required",
  password_characters: "Password needs to have at least 8 characters",
  passwrod_max_length: "Password maximum length is 30 characters",
  terms_and_conditions_required: "Terms and conditions are required",
  user_role_required: "User role is required.",
  old_password_required: "Old Password is required",
  user_language_changed_successfully: "User language changed successfully",
  // yup password validations
  new_password_required: "New password is required",
  repeat_password_required: "Repeat password is required",
  old_and_new_password_must_be_different:
    "Old and new passwords must be different",
  new_and_repeat_password_must_match: "New and repeat passwords must match",
  password_must_be_at_least: "Password must have at least 8 characters",
  password_must_contain:
    "Password must contain at least one uppercase letter, one lowercase letter, one number, and one symbol",
  field_required: "This field is required",
  // Cookie and Privacy Policy
  cookie_alert_text: `We use cookies to improve your experience on our site. To find out more, read our `,
  cookie_policy: "Cookie Policy",
  cookie_policy_title: "Cookie policy",
  cookie_policy_user: `
      <p>
          Cookies are used to enable a service provided by the web page, as well as to improve a service and/or
          better to comply with Your needs.
      </p>
      <h5>Types of cookies which we use;</h5>

      <p>The cookies used are strictly necessary cookies which track the service and without the use of which the
          service will not be able to operate, therefore cannot be deactivated.</p>
      <h5>AbSent user cookie consent</h5>

      <p>With every visit of the web page by the User the strictly necessary cookies are activated, without which
          the service cannot be provided.</p>

      <p>Below follows the description of cookies which are used when using AbSent with their functionality:</p>

      <table class="table table-striped">
          <thead>
              <tr>
                  <th scope="col">No:</th>
                  <th scope="col">Cookie/file/data name</th>
                  <th scope="col">Functionality</th>
              </tr>
          </thead>
          <tbody>
              <tr>
                  <th scope="row">1</th>
                  <td>XSRF-TOKEN</td>
                  <td>
                      System protection in a form of random string that protect the site of hack attacks, ,
                      without taking your personal informations in any way.
                  </td>
              </tr>
              <tr>
                  <th scope="row">2</th>
                  <td>absent_session</td>
                  <td>
                      Store system data, without taking your personal informations in any way.
                  </td>
              </tr>
              <tr>
                  <th scope="row">3</th>
                  <td>_ga, _gid</td>
                  <td>
                      These cookies are used to collect information about how visitors use our site. We use the
                      information to compile reports and to help us improve the site. The cookies collect
                      information in an anonymous form, including the number of visitors to the site, where
                      visitors have come from geographically, and the pages they have visited, the devices and
                      browsers the visitor is using.
                  </td>
              </tr>
              <tr>
                  <th scrop="row">4</th>
                  <td>absent-cookie-policy-consent</td>
                  <td>
                      This cookie is used to record if a visitor has seen our cookie policy notification bar.
                  </td>
              </tr>
          </tbody>
      </table>

      <p>
          Last updated on 1/1/2020
      </p>
    `, //end of user cookie policy description

  i_agree: "I agree",

  privacy_policy_title: "Privacy policy",
  privacy_policy_user: `
      <p>
          This privacy policy explains how we, the Company for engineering SENTICE TECH LLC Skopje, acting as the
          Processor (hereinafter: Sentice), collect and process data for you and your use of the Mobile and web
          application AbSent (hereinafter: Personal data), in order to provide You with our service, as the
          employees of your Employer.
      </p>

      <p>
          To be more specific, this privacy policy explains how we collect, use and process personal data, and
          cases when we may reveal personal data with regards to Your use of the service via AbSent – an
          application for absence management in compliance with the laws, agreed obligations and joint legitimate
          interests (recording absence from work).
      </p>

      <p>
          We obtain some of your data from Your Employer, who records the data in AbSent to create Your personal
          user account, with which you can independently continue using the service by submitting absences from
          work.
      </p>

      <h5>How we collect and use personal data</h5>
      <p>
          The data collected is obtained through Your Employer, who provides us with the data in order to create
          Your personal user account; to achieve this the Employer or an authorized person enters the data
          independently in the Application: AbSent.
      </p>
      <p>
          We receive the following data:
      </p>
      <ul class="dashed">
          <li>
              name and surname,
          </li>
          <li>
              phone number,
          </li>
          <li>
              date of birth,
          </li>
          <li>
              nationality and religion.
          </li>
      </ul>

      <p>
          Aim: We use Your personal data exclusively to fulfill the agreed obligations with Your Employer, as well
          as to provide You with the service of managing your personal absences via AbSent.
      </p>
      <p>
          We collect your personal data which your employee and you give us voluntarily.
      </p>

      <h5>Automatic data collection</h5>
      <p>
          Data is also collected automatically, via cookies. This data is used in order to provide and improve the
          service.
      </p>
      <p>
          The data does not include Your content or data generated by you.
      </p>
      <p>
          For further information about how data is collected and processed via automatic collection by using
          cookies, read the <a href="/cookie-policy" target="_blank">Cookies Policy</a>.
      </p>
      <p>
          Apart from using the above mentioned data, when the need arises we may as well use the IP address that
          you use to access the service as well as other data that may reveal Your identity, only when this is
          necessary and obligatory so as to comply with the law.
      </p>
      <h5>Storage and data transfer</h5>
      <h6>For better and complete protection, the Company uses a cloud based back-up system on servers located in
          the European Union, to be more specific in Frankfurt, Germany.</h6>
      <h6>With reference to processing Your data, You have the following rights:</h6>
      <p>
      <ul class="dashed">
          <li>the right to access and edit my personal data;</li>
          <li>
              the right to block my personal data processing due to specific reasons;
          </li>
          <li>
              the right to object to, as well as the right to transfer my personal data to a different controller,
              in the appropriate form;
          </li>
      </ul>
      </p>

      <h5>The right to access personal data</h5>
      <p>
          The right to access: we are informing you with this policy that we do not enter, update and/or delete
          personal data which is entered by Your Employer or personally by You. If you demand the right to access,
          update or delete data, this can be achieved through your Employer, who has entered the data i.e. who has
          the authority to enter, update and delete data instead of you.
      </p>

      <p>
          We only store the data entered by You or Your Employer on a server, in order to fulfill the agreed
          obligations so that you can use the service. This data is stored encrypted and is not intelligible.
      </p>

      <h5>Data protection</h5>
      <p>
          We introduce reasonable measures to provide proper physical, technical and electronic data protection.
      </p>
      <p>
          We implement safety measures for physical and technical data protection from loss, destruction and
          unauthorized access, publication or unauthorized entry.
      </p>
      <p>
          Despite these measures, there is not a safety measure that guarantees full (100%) protection during the
          whole time period.
      </p>

      <h5>Manner of notification in case of changes to the privacy policy</h5>

      <p>
          Updates to the privacy policy. This privacy policy may undergo certain updates from time to time in
          compliance with the changes of the personal data protection regulations. We will inform you of every
          change which refers to the manner in which your previously collected data is manipulated, and you will
          be given the option to choose if you would like to continue using it.
      </p>

      <p>
          Last updated on 1/1/2020
      </p>
    `, //end of user privacy policy description

  privacy_policy_user_modal: `
      <p>
          This privacy policy explains how we, the Company for engineering SENTICE TECH LLC Skopje, acting as the
          Processor (hereinafter: Sentice), collect and process data for you and your use of the Mobile and web
          application AbSent (hereinafter: Personal data), in order to provide You with our service, as the
          employees of your Employer.
      </p>

      <p>
          To be more specific, this privacy policy explains how we collect, use and process personal data, and
          cases when we may reveal personal data with regards to Your use of the service via AbSent – an
          application for absence management in compliance with the laws, agreed obligations and joint legitimate
          interests (recording absence from work).
      </p>

      <p>
          We obtain some of your data from Your Employer, who records the data in AbSent to create Your personal
          user account, with which you can independently continue using the service by submitting absences from
          work.
      </p>

      <h5>How we collect and use personal data</h5>
      <p>
          The data collected is obtained through Your Employer, who provides us with the data in order to create
          Your personal user account; to achieve this the Employer or an authorized person enters the data
          independently in the Application: AbSent.
      </p>
      <p>
          We receive the following data:
      </p>
      <ul class="dashed">
          <li>
              name and surname,
          </li>
          <li>
              phone number,
          </li>
          <li>
              date of birth,
          </li>
          <li>
              nationality and religion.
          </li>
      </ul>

      <p>
          Aim: We use Your personal data exclusively to fulfill the agreed obligations with Your Employer, as well
          as to provide You with the service of managing your personal absences via AbSent.
      </p>
      <p>
          We collect your personal data which your employee and you give us voluntarily.
      </p>

      <h5>Automatic data collection</h5>
      <p>
          Data is also collected automatically, via cookies. This data is used in order to provide and improve the
          service.
      </p>
      <p>
          The data does not include Your content or data generated by you.
      </p>
      <p>
          Apart from using the above mentioned data, when the need arises we may as well use the IP address that
          you use to access the service as well as other data that may reveal Your identity, only when this is
          necessary and obligatory so as to comply with the law.
      </p>
      <h5>Storage and data transfer</h5>
      <h6>For better and complete protection, the Company uses a cloud based back-up system on servers located in
          the European Union, to be more specific in Frankfurt, Germany.</h6>
      <h6>With reference to processing Your data, You have the following rights:</h6>
      <p>
      <ul class="dashed">
          <li>the right to access and edit my personal data;</li>
          <li>
              the right to block my personal data processing due to specific reasons;
          </li>
          <li>
              the right to object to, as well as the right to transfer my personal data to a different controller,
              in the appropriate form;
          </li>
      </ul>
      </p>

      <h5>The right to access personal data</h5>
      <p>
          The right to access: we are informing you with this policy that we do not enter, update and/or delete
          personal data which is entered by Your Employer or personally by You. If you demand the right to access,
          update or delete data, this can be achieved through your Employer, who has entered the data i.e. who has
          the authority to enter, update and delete data instead of you.
      </p>

      <p>
          We only store the data entered by You or Your Employer on a server, in order to fulfill the agreed
          obligations so that you can use the service. This data is stored encrypted and is not intelligible.
      </p>

      <h5>Data protection</h5>
      <p>
          We introduce reasonable measures to provide proper physical, technical and electronic data protection.
      </p>
      <p>
          We implement safety measures for physical and technical data protection from loss, destruction and
          unauthorized access, publication or unauthorized entry.
      </p>
      <p>
          Despite these measures, there is not a safety measure that guarantees full (100%) protection during the
          whole time period.
      </p>

      <h5>Manner of notification in case of changes to the privacy policy</h5>

      <p>
          Updates to the privacy policy. This privacy policy may undergo certain updates from time to time in
          compliance with the changes of the personal data protection regulations. We will inform you of every
          change which refers to the manner in which your previously collected data is manipulated, and you will
          be given the option to choose if you would like to continue using it.
      </p>

      <p>
          Last updated on 1/1/2020
      </p>
    `,
  OK: "OK",

  no_right_to_use_vacation: "You are not allowed to request vacation days in the selected period. Please contact your company management, or HR, for support.",
  cannot_take_vacation_in_selected_period:
    "You can not take a vacation in the selected period",
  days_exceed_annual_limit:
    "The required days are more than the days for annual leave in this period",
  overlapping_personal_days:
    "Personal days end period is overlapping with another absence",
  overlapping_absence: "User already has an absence in this period",
  overlapping_period_or_switch_day:
    "User already has an absence with this period/switch day",
  wrong_old_password: "Old password does not match our records",

  re_type_new_password: "Re-type new password",
  save: "Save",
  successfully_logged_in:
    "You are successfully logged in, please change your password",
  error_try_again_later: "Something went wrong. Please try again later.",
  error_creating_absence: "Error creating absence",
  absence_declined: "Absence declined.",
  absence_approved:"Absence was successfully approved",
  expired_password:"Your password has expired, please change it.",
  current_password:"Current password",
  confirm_new_password:"Confirm New Password",
  reset_password:"Reset Password",
    login: "Login",
  page_not_found: "Page not found.",
  go_back_to_home_page: "Go back to home page",

  last_reason_for_update: "Last reason for update",
  reason_for_update: "Reason for update",
  comment_for_this_presence: "Comment for this presence",
  absent_members: "member/s are absent on this day",

  Other: "Other",

  //months - short translation
  Jan: "Jan",
  Feb: "Feb",
  Mar: "Mar",
  Apr: "Apr",
  May: "May",
  Jun: "Jun",
  Jul: "Jul",
  Aug: "Aug",
  Sep: "Sep",
  Oct: "Oct",
  Nov: "Nov",
  Dec: "Dec",
  login: {
    "join_system": "JOIN OUR GREAT ABSENCE MANAGEMENT SYSTEM",
    "email": "Email",
    "password": "Password",
    "remember_me": "Remember Me",
    "forgot_password": "Forgot Password?",
    "2fa_code": "Enter 2FA Code",
    "resending": "Resending...",
    "resend_code": "Resend code",
    "login": "LOGIN",
    "verify": "VERIFY",
    "invalid_or_expired_2fa_token": "Invalid or expired 2FA token.",
    "invalid_credentials": "Invalid credentials",
    "resend_failed": "Failed to resend code.",
    "user_is_blocked": "User is blocked.",
    failed: "Login failed.",
    invalid_2fa: "Invalid 2FA code.",
    resend_failed: "Failed to resend code.",
    password_min_length: "Password must be at least 8 characters.",
    password_uppercase: "Password must contain at least one uppercase letter.",
    password_lowercase: "Password must contain at least one lowercase letter.",
    password_number: "Password must contain at least one number.",
    password_special: "Password must contain at least one special character.",
    passwords_do_not_match: "Passwords do not match.",
    password_reset_success: "Password reset successful!",
    user_not_found: "User not found.",
    invalid_code: "Invalid code.",
    invalid_or_expired_code: "Invalid or expired code.",
    email_not_verified: "Email not verified.",
    user_is_blocked: "User is blocked.",
    code_valid: "Code is valid.",
    password_expired: "Your password has expired. Please reset it.",
    password_reset_email_sent: "Password reset email sent.",
    reset_code_sent: "Reset code sent.",
  },

  "absences": {
    "Annual leave Unused": "Annual leave - Unused",
    "Annual leave Pending": "Annual leave - Pending",
    "Annual leave Used": "Annual leave - Used",
    "Name of vacation": "Name of vacation",
    "Personal days": "Personal days",
    "Sick leave": "Sick leave",
    "Business trip": "Business trip",
    "Work from home": "Work from home",
    "Extra days": "Extra days",
    "Paid parental leave": "Paid parental leave",
    "Unpaid parental leave": "Unpaid parental leave",
    "Unpaid leave": "Unpaid leave",
  },

  "presence_report_names": {
    "Person": "Person",
    "Work": "Work",
    "Paid Break": "Paid Break",
    "Field work": "Field work",
    "Absence": "Absence",
    "Holiday": "Holiday",
    "Total regular time": "Total regular time",
    "Expected regular time": "Expected regular time",
    "Expected and total time difference": "Expected and total time difference",
    "Total scheduled": "Total scheduled",
    "Overtime": "Overtime",
    "Expected and total time difference with overtime": "Expected and total time difference with overtime",
    "Presence on night work": "Presence on night work",
    "Presence on absence": "Presence on absence",
    "Presence on holiday": "Presence on holiday",
    "Presence on rest day": "Presence on rest day",
    "Total Logged Hours": "Total Loged Hours",
    "Private exit": "Private exit",
    "Unauthorized Absence": "Unauthorized Absence",
    "Exceeded break": "Exceeded break",
    "Unpaid absence": "Unpaid absence",
    "Day": "Day",
    "Date": "Date",
    "Schedule start time": "Schedule start time",
    "Logged start time": "Logged start time",
    "Schedule end time": "Schedule end time",
    "Logged end time": "Logged end time",
    "Work": "Work",
    "Paid break": "Paid break",
    "Field work": "Field work",
    "Absence": "Absence",
    "Holiday": "Holiday",
    "Total logged time": "Total logged time",
    "Expected regular time": "Expected regular time",
    "Expected and total time difference": "Expected and total time difference",
    "Total schedule time": "Total schedule time",
    "Overtime": "Overtime",
    "Expected and total time difference with overtime": "Expected and total time difference with overtime",
    "Presence on night work": "Presence on night work",
    "Presence on absence": "Presence on absence",
    "Presence on holiday": "Presence on holiday",
    "Presence on rest day": "Presence on rest day",
    "Total Logged Hours": "Total Loged Hours",
    "Private exit": "Private exit",
    "Unauthorized Absence": "Unauthorized Absence",
    "Exceeded break": "Exceeded break",
    "Unpaid absence": "Unpaid absence",
    "Note": "Note",
  },
  
  'Default': 'Default',
  'Deactivated': 'Deactivated',
  'Mon': 'Mon',
  'Tue': 'Tue',
  'Wed': 'Wed',
  'Thu': 'Thu',
  'Fri': 'Fri',
  'Sat': 'Sat',
  'Sun': 'Sun',
  'Work': 'Work',
  'Break': 'Paid break',
  'Field work': 'Field work',
  'Private exit': 'Private exit',
  'Work on absence': 'Work on absence',
  'Break on absence': 'Paid break on absence',
  'Field work on absence': 'Field work on absence',
  'Work on holiday': 'Work on holiday',
  'Break on holiday': 'Paid break on holiday',
  'Field work on holiday': 'Field work on holiday',
  'Unauthorized Absence': 'Unauthorized absence',
  'Work on rest day': 'Work on rest day',
  'Field work on rest day': 'Field work on rest day',
  'Break on rest day': 'Paid break on rest day',
  'Work on night work': 'Work on night work',
  'Field work on night work': 'Field work on night work',
  'Break on night work': 'Paid break on night work',
    
  "day": {
    "Mon": "Mon",
    "Tue": "Tue",
    "Wed": "Wed",
    "Thu": "Thu",
    "Fri": "Fri",
    "Sat": "Sat",
    "Sun": "Sun"
  },
  // "teamTranslation": {
  //   "Default": "Default",
  // },
  //   "departmentTranslation": {
  //   "Default": "Default",
  // }
    "allRoles": {
    "Manager": "General Manager",
    "Chairman": "Chairman",
    "Human Resources": "Human Resources",
    "Team Lead": "Team Lead",
    "Team Member": "Team Member",
    "Department Lead": "Department Manager",
    "System Administrator": "System Administrator"
  },
   manager: "General Manager",
   owner: "Chairman",
    "roles": {
    "System Administrator-sysadmin": "System Administrator",
    "Chairman-owner": "Chairman",
    "Department Manager-deplead": "Department Manager",
    "Team Lead-teamlead": "Team Lead",
    "Team Member-teammember": "Team Member",
    "Human Resources-administration": "Human Resources",
    "Генерален менаџер-manager": "General Manager",
    "Претседател-owner": "Chairman",
    "Човечки ресурси-administration": "Human Resources",
    "Менаџер на оддел-deplead": "Department Manager",
    "Тим лидер-teamlead": "Team Lead",
    "Член на тим-teammember": "Team Member",
    "Систем aдминистратор-sysadmin": "System Administrator",
    "Управител-manager": "General Manager",
    "Системен администратор-sysadmin": "System Administrator",
    "Човешки ресурси-administration": "Human Resources",
    "Председател-owner": "Chairman",
    "Ръководител на отдел-deplead": "Department Manager",
    "Ръководител на екипа-teamlead": "Team Lead",
    "Член на екипа-teammember": "Team Member"
  },
  vacation_period_desc: "Period of usage on vacation",
  document_full_name_desc: "Full name of the applicant which was inputted on his local language",
  birthday_desc: "Birthday date of the applicant",
  document_job_position_desc: "Job position of the applicant which was inputted on his local language",
  requested_days_desc: "Requested days by the applicant",
  next_day_desc: "Calculated day for the applicant when should be back to work",
  display_leave_type_desc: "Type of leave",
  start_day_desc: "Start date of the absence request",
  end_day_desc: "End date of the absence request",
  display_full_name_desc: "Full name of the applicant",
  display_job_position_desc: "Job position of the applicant",
  email_desc: "Email of the applicant",
  team_desc: "Team of the applicant",
  empl_start_day_desc: "Employment start date of the applicant",
  phone_desc: "Phone of the applicant",
  document_leave_type_desc: "Type of leave of the applicant which was inputted on his local language",
  absent_created_desc: "Date when absence is created",
  absent_change_status_desc: "Date when absence status is changed",
  submited_tag_desc: "Submitted By",
  gm_tag_desc: "Tag for General Manager",
  hr_tag_desc: "Tag for Human resources",
  dl_tag_desc: "Tag for Department Manager",
  tl_tag_desc: "Tag for Team lead",
  submited_time_tag_desc: "A time when the request was submitted",
  gm_approved_time_tag_desc: "A time when the request is approved by the General Manager",
  hr_approved_time_tag_desc: "A time when the request is approved by the Human resources",
  dl_approved_time_tag_desc: "A time when the request is approved by the Department Manager",
  tl_approved_time_tag_desc: "A time when the request is approved by the Team lead",
  absence_comment_desc: "Comment from absence request",
  submited_date_tag_desc: "The date when the request was submitted",
  gm_approved_date_tag_desc: "The date when the request is approved by the General Manager",
  hr_approved_date_tag_desc: "The date when the request is approved by the Human resources",
  dl_approved_date_tag_desc: "The date when the request is approved by the Department Manager",
  tl_approved_date_tag_desc: "The date when the request is approved by the Team lead",
  vacation_title_desc: "Vacation title",
  copy_tag: "Copy tag",
  upload_annual_leave_template: "Upload Annual Leave Template",
  upload_paid_holidays_template: "Upload Paid Holidays Template",
  upload_work_from_home_template: "Upload Work From Home Template",
  download_template: "Download Template",
  drag_or_click_to_upload: "Drag and drop or click to upload",
  how_to_make_documents: "How to make documents?",
  document_templates_help_1: "In order to automatically generate employee's documents, you should add document templates.",
  document_templates_help_2: "These templates should contain some here listed tags of your choice, of your needs. Of course, you do not have to use all of them, but it is very likely that you will want to use some of them.",
  document_templates_help_3: "On the link below, you can download example template.",
  document_templates_help_4: "Even if you do not intend to use all of the document templates, please upload empty .docx files.",
  download_example_template: "Download example template",
  help: "Help",
  not_uploaded_annual_leave_template: "Annual leave template is not uploaded",
  not_uploaded_paid_holidays_template: "Paid holidays template is not uploaded",
  not_uploaded_work_from_home_template: "Work from home template is not uploaded",
  company: "Company",
  document_templates: "Document templates",
  document_templated_uploads: "Document template uploads",
  tags: "Tags",
  tags_description: "Tags description",
  template_successfully_uploaded: "Template was successfully uploaded",
  upload_failed: "Upload failed",
  copied_to_clipboard: "Tag copied!",
  departmentTranslation: {
    "Default": "Default", 
    "Основен": "Default", 
    "Основен": "Default", 
  },
  teamTranslation: {
    "Default": "Default", 
    "Основен": "Default", 
    "Основен": "Default", 
  },
  details: "Details",
  company_details: "Company Details",
  name: "Name",
  address: "Address",
  leader_of_default_team_and_department: "Leader of Default Team and Department",
  city: "City",
  tax_number: "Tax Number",
  enter_company_tax_number: "Enter company tax number",
  optional: "(Optional)",
  country: "Country",
  company_logo: "Company Logo",
  change_logo: "Change Logo",
  upload_logo: "Upload Logo",
  save: "Save",
  select_country: "Select a country",
  search: "Search",
  frequent_countries: "Frequent Countries",
  all_countries: "All Countries",
  manager_required: "Manager is required",
  name_required: "Name is required",
  address_required: "Address is required",
  city_required: "City is required",
  country_required: "Country is required",
  no_changes_to_save: "There are no changes to save",
  failed_to_load_company_details: "Failed to load company details",
  company_updated_successfully: "Company updated successfully",
  failed_to_update_company: "Failed to update company",
  validation_error: "Validation error",
  please_fill_required_fields: "Please fill all required fields",
  logo_must_be_image: "Logo must be an image",
  info_title: "Info",
  error: "Error",
  success: "Success",
  login: {
    "join_system": "JOIN OUR GREAT ABSENCE MANAGEMENT SYSTEM",
    "email": "Email",
    "password": "Password",
    "remember_me": "Remember Me",
    "forgot_password": "Forgot Password?",
    "2fa_code": "Enter 2FA Code",
    "resending": "Resending...",
    "resend_code": "Resend code",
    "login": "LOGIN",
    "verify": "VERIFY",
    "invalid_or_expired_2fa_token": "Invalid or expired 2FA token.",
    "invalid_credentials": "Invalid credentials",
    "resend_failed": "Failed to resend code.",
    "user_is_blocked": "User is blocked.",
    "failed": "Login failed.",
    "invalid_2fa": "Invalid 2FA code.",
    "resend_failed": "Failed to resend code.",
    "password_min_length": "Password must be at least 8 characters.",
    "password_uppercase": "Password must contain at least one uppercase letter.",
    "password_lowercase": "Password must contain at least one lowercase letter.",
    "password_number": "Password must contain at least one number.",
    "password_special": "Password must contain at least one special character.",
    "passwords_do_not_match": "Passwords do not match.",
    "password_reset_success": "Password reset successful!",
    "user_not_found": "User not found.",
    "invalid_code": "Invalid code.",
    "invalid_or_expired_code": "Invalid or expired code.",
    "email_not_verified": "Email not verified.",
    "user_is_blocked": "User is blocked.",
    "code_valid": "Code is valid.",
    "password_expired": "Your password has expired. Please reset it.",
    "password_reset_email_sent": "Password reset email sent.",
    "reset_code_sent": "Reset code sent.",
    "send_reset_code": "Send Reset Code",
    "back_to_login": "Back to Login",
    "otp_timer": "OTP Timer",
    "verify_code": "Verify Code",
    "reset_password": "Reset Password",
    "new_password": "New Password",
    "confirm_password": "Confirm New Password",
  },

  languages: {
    "gb": "English",
    "mk": "Македонски",
    "bg": "Български",
  },
  loginPage: "Login",
  terms_and_conditions_title: "Terms and Conditions",
};
